<template>
    <nav class="navbar-default navbar-static-side" role="navigation">
        <div class="sidebar-collapse">
            <ul class="nav metismenu" id="side-menu">
                <li class="nav-header">
                    <div class="dropdown profile-element">
                        <a data-toggle="dropdown" class="dropdown-toggle" href="#" @click.prevent>
                            <span class="block m-t-xs font-bold">{{ name }}</span>
                            <span class="text-muted text-xs block">{{ position_title }}</span>
                        </a>
                    </div>
                    <div class="logo-element p-0">
                        <svg style="fill: #fff;" xmlns="http://www.w3.org/2000/svg" viewBox="100 150 242 230"><path shape-rendering="geometricPrecision" d="M171.14 324.54h13.6s15.03-26.34 31.23-48.16c10.1-13.6 18.14-23.57 28-31.96 7.2-6.12 11.16-9.67 20.83-10.84 7.15-.87 5.48 6.83 5.39 7.68-.1.86-2.24 8.06-6.58 18L247.18 297l-18.42 42.5 12.41 5.1 32.37-78.51 5.53-13.58s7.48-15.9-1.02-19.99c-7.71-3.7-18.4-.98-23.1 1.25 0 0-9.71 4.81-19.47 14.5s-24.84 29.38-33.13 41.89c-8.29 12.5-13.33 20.68-13.33 20.68s12.9-26.7 18.69-40.14c5.78-13.44 8.64-26.43 8.42-29.52-.22-3.1-.28-8.3-6.98-9.51-4.96-.9-13.8 1.25-19.2 4.67-5.42 3.41-15.24 11.55-23.3 21.65-5.18 6.5-4.18 5.53-4.18 5.53l7.48 7.82s16.8-28.78 28.14-35.5c2.96-1.74 6.37-2.96 8.57-1.33 2.19 1.63-.48 7.85-.67 8.44-.2.6-1.18 4.8-9.74 24.24l-18.5 42.03-6.61"></path></svg>
                    </div>
                </li>
                <router-link to="/dashboard" tag="li" v-if="hasPrivilege([1])" >
                    <a>
                        <i class="fa fa-th-large"></i>
                        <span class="nav-label">{{ $t('dashboard') }}</span>
                    </a>
                </router-link>

                <!-- <router-link to="/cglink" tag="li" v-if="hasPrivilege([1])" >
                    <a>
                        <i class="fas fa-link"></i>
                        <span class="nav-label">Cglink</span>
                    </a>
                </router-link> -->

                <!-- <router-link to="/competition-on-wave" tag="li" v-if="hasPrivilege([1, 22])" >
                    <a>
                        <i class="fas fa-trophy"></i>
                        <span class="nav-label">{{ $t('contest_on_wave') }}</span>
                    </a>
                </router-link>

                <router-link to="/15th-birthday" tag="li" v-if="hasPrivilege([1,22,23])" >
                    <a>
                        <i class="fas fa-gift"></i>
                        <span class="nav-label">{{ $t('contest') }} 2021 15th Birthday</span>
                    </a>
                </router-link>

                <router-link to="/paradise" tag="li" v-if="hasPrivilege([1, 22])" >
                    <a>
                        <i class="fab fa-pagelines"></i>
                        <span class="nav-label">{{ $t('contest') }} 2021</span>
                    </a>
                </router-link>

                <router-link to="/competition" tag="li" v-if="hasPrivilege([1, 22])" >
                    <a>
                        <i class="fas fa-air-freshener"></i>
                        <span class="nav-label">{{ $t('contest') }} 2020</span>
                    </a>
                </router-link> -->

                <!-- <router-link
                    v-if="hasPrivilege([1,5,17,27,25,23])"
                    to="/uslugi"
                    tag="li"
                >
                    <a>
                        <i class="fas fa-hammer"></i>
                        <span class="nav-label">{{ $t('services') }}</span>
                    </a>
                </router-link> -->

                <!-- <li v-if="hasPrivilege([1,5,10,12,20,23])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#collapseReport" aria-expanded="false">
                        <i class="fa fa-bar-chart-o"></i>
                        <span class="nav-label">{{ $t('sales_report') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="collapseReport">
                        <router-link to="/raport-sprzedazy" tag="li">
                            <a>
                                {{ $t('sales_report') }}
                            </a>
                        </router-link>
                        <li>
                            <a data-toggle="collapse" href="#collapseReportNeoNailPLSell" aria-expanded="false">
                                {{ $t('shop_neonail_pl') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseReportNeoNailPLSell">
                                <router-link to="/pl/neonail/raport" tag="li">
                                    <a>
                                        {{ $t('sales_report') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/neonail/raports/category" tag="li">
                                    <a>
                                        {{ $t('category_report') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li>
                    </ul>
                </li> -->

                <li v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,19,21,23,26])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#collapseNeoNailPL" aria-expanded="false">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="nav-label">{{ $t('shop_neonail_pl') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="collapseNeoNailPL">

                        <!-- <li v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,19,21,23,26])" >
                            <a data-toggle="collapse" href="#collapseNeoNailPLSell" aria-expanded="false">
                                {{ $t('sele') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailPLSell"> -->
                                <!-- <router-link to="/pl/neonail/bestseller" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('bestseller') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/darmowa-dostawa-statystyka" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('free_delivery') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/zamowienia" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('order_list') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/numery-zamowien" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,19,23,26])">
                                        {{ $t('order_numbers') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/zamowienia-niewyslane" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                                        {{ $t('order_list') }} niewysłane
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/zamowienia-uwagi" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('notes_for_orders') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/sprzedaz-produktu" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('product_sale') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/sprzedaz-po-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('sale_by_category') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/sprzedaz-promocji" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('sale_promotion') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/sprzedaz-promocji-v2" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('sale_promotion') }} V2
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/sprzedaz-kolekcje" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('sale_collection') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/products_sales2" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                        {{ $t('products_sales2') }}
                                    </a>
                                </router-link> -->
                            <!-- </ul>
                        </li> -->
                        <!-- <li v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,21,23,26])" >
                            <a data-toggle="collapse" href="#collapseNeoNailPLProducts" aria-expanded="false">
                                {{ $t('products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailPLProducts"> -->
                                <!-- <router-link to="/pl/neonail/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23,26])" >
                                        {{ $t('list_of_products') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/produkty-do-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23,26])" >
                                        {{ $t('assigning_products_to_categories') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/produkty-symbol" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23,26])" >
                                        {{ $t('list_of_plum_by_category') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/produkty-price-change" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25])" >
                                        Zmiana ceny
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/pl/neonail/produkty-sprzedaz" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,21,23,26])" >
                                        {{ $t('sale_products') }}
                                    </a>
                                </router-link>
                                <li>
                                    <a @click.prevent="exportTree('/pl/neonail/')">
                                        {{ $t('category_tree') }}
                                    </a>
                                </li> -->
                            <!-- </ul>
                        </li> -->
                        <!-- <router-link to="/pl/neonail/kody-rabatowe" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25])">
                                {{ $t('discount_codes') }}
                            </a>
                        </router-link> -->
                        <!-- <li v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23,26])" >
                            <a data-toggle="collapse" href="#collapseNeoNailPLDiscountCodes" aria-expanded="false">
                                {{ $t('discount_codes') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailPLDiscountCodes">
                                <router-link to="/pl/neonail/kody-rabatowe" tag="li">
                                    <a>
                                        {{ $t('discount_codes_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/neonail/kody-rabatowe-sprzedaz" tag="li">
                                    <a>
                                        {{ $t('sale_discount_codes') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/pl/neonail/newsletter" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                                {{ $t('newsletter') }}
                            </a>
                        </router-link> -->
                        <li v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                            <a data-toggle="collapse" href="#collapseNeoNailPLGiftCards" aria-expanded="false">
                                {{ $t('gift_cards') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailPLGiftCards">
                                <router-link to="/pl/neonail/karty-podarunkowe" tag="li">
                                    <a>
                                        {{ $t('gift_cards_list') }}
                                    </a>
                                </router-link>
                                <!-- <router-link to="/pl/neonail/karty-podarunkowe/dodaj" tag="li">
                                    <a>
                                        {{ $t('add_a_gift_card') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/neonail/karty-podarunkowe/uzyte" tag="li">
                                    <a>
                                        {{ $t('the_number_of_gift_cards_used') }}
                                    </a>
                                </router-link> -->
                            </ul>
                        </li>
                        <!-- <li v-if="hasPrivilege([1])" >
                            <a data-toggle="collapse" href="#collapseNeoNailPLLoyaltyCards" aria-expanded="false">
                                {{ $t('customers') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailPLLoyaltyCards">
                                <router-link to="/pl/neonail/klienci" tag="li">
                                    <a>
                                        {{ $t('customers_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/neonail/karty-lojalnosciowe-kontrola" tag="li">
                                    <a>
                                        {{ $t('checking_loyalty_cards') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/neonail/klient-liczba-zamowien" tag="li">
                                    <a>
                                        {{ $t('number_of_orders_by_the_customer') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/pl/neonail/nasze-promocje" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                                Nasze promocje
                            </a>
                        </router-link>
                        <router-link to="/pl/neonail/nasze-nowosci" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                                Nasze nowości
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/pl/neonail/metody-platnosci-statystyki" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                {{ $t('payment_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/pl/neonail/metody-dostawy-statystyki" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23,26])">
                                {{ $t('delivery_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/pl/neonail/konfigurator-zestawow" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                                {{ $t('set_configurator') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/pl/neonail/vat" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23])">
                                {{ $t('vat') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/pl/neonail/faq" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23,26])">
                                Faq
                            </a>
                        </router-link> -->
                        <!-- <router-link
                            to="/pl/neonail/inspiracje"
                            tag="li"
                            v-if="hasPrivilege([1])"
                        >
                            <a>
                                {{ $t('inspirations') }}
                            </a>
                        </router-link> -->
                    </ul>
                </li>
                <!-- <li v-if="hasPrivilege([1,3,5,12,14,15,17,27,25,19,21,23])">
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#collapseNeoNailDE" aria-expanded="false">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="nav-label">{{ $t('shop_neonail_de') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="collapseNeoNailDE"> -->

                        <!-- <li v-if="hasPrivilege([1,3,5,12,14,15,17,27,25,19,21,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailDESell" aria-expanded="false">
                                {{ $t('sele') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,19,21,23])" class="nav nav-third-level collapse" id="collapseNeoNailDESell">
                                <router-link to="/de/neonail/bestseller" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('bestseller') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/darmowa-dostawa-statystyka" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('free_delivery') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/zamowienia" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('order_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/numery-zamowien" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,19,23])">
                                        {{ $t('order_numbers') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/zamowienia-uwagi" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('notes_for_orders') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/sprzedaz-produktu" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('product_sale') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/sprzedaz-po-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('sale_by_category') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <li v-if="hasPrivilege([1,2,3,5,12,14,15,17,27,25,21,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailDEProducts" aria-expanded="false">
                                {{ $t('products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailDEProducts"> -->
                                <!-- <router-link to="/de/neonail/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23])" >
                                        {{ $t('list_of_products') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/de/neonail/produkty-sprzedaz" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,21,23])" >
                                        {{ $t('sale_products') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/de/neonail/produkty-do-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25])" >
                                        {{ $t('assigning_products_to_categories') }}
                                    </a>
                                </router-link> -->
                                <!-- <li>
                                    <a @click.prevent="exportTree('/de/neonail/')">
                                        {{ $t('category_tree') }}
                                    </a>
                                </li> -->
                            <!-- </ul>
                        </li> -->
                        <!-- <router-link to="/de/neonail/kody-rabatowe" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25])">
                                {{ $t('discount_codes') }}
                            </a>
                        </router-link> -->
                        <!-- <li v-if="hasPrivilege([1,2,3,5,12,14,15,17,27,25,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailDEDiscountCodes" aria-expanded="false">
                                {{ $t('discount_codes') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailDEDiscountCodes">
                                <router-link to="/de/neonail/kody-rabatowe" tag="li">
                                    <a>
                                        {{ $t('discount_codes_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/kody-rabatowe-sprzedaz" tag="li">
                                    <a>
                                        {{ $t('sale_discount_codes') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/de/neonail/newsletter" tag="li">
                            <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,23])">
                                {{ $t('newsletter') }}
                            </a>
                        </router-link> -->
                        <!-- <li v-if="hasPrivilege([1])" >
                            <a data-toggle="collapse" href="#collapseNeoNailDELoyaltyCards" aria-expanded="false">
                                {{ $t('customers') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailDELoyaltyCards">
                                <router-link to="/de/neonail/klient-liczba-zamowien" tag="li">
                                    <a>
                                        {{ $t('number_of_orders_by_the_customer') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/de/neonail/metody-platnosci-statystyki" tag="li">
                            <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                {{ $t('payment_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/de/neonail/metody-dostawy-statystyki" tag="li">
                            <a v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,21,23])">
                                {{ $t('delivery_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/de/neonail/vat" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23])">
                                {{ $t('vat') }}
                            </a>
                        </router-link> -->
                        <!-- <li v-if="hasPrivilege([1,3,5,12,13,14,15,17,27,25,23])">
                            <a data-toggle="collapse" href="#collapseNeoNailDEComplaint" aria-expanded="false">
                                {{ $t('complaints') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailDEComplaint">
                                <router-link to="/de/neonail/reklamacje" tag="li">
                                    <a>
                                        {{ $t('list_of_requests') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/neonail/reklamacje/ustawienia" tag="li">
                                    <a>
                                        {{ $t('settings') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                    <!-- </ul>
                </li> -->
                <!-- <li v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,19,21,23])">
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#collapseNeoNailES" aria-expanded="false">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="nav-label">{{ $t('shop_neonail_es') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="collapseNeoNailES"> -->

                        <!-- <li v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,19,21,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailESSell" aria-expanded="false">
                                {{ $t('sele') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,19,21,23])" class="nav nav-third-level collapse" id="collapseNeoNailESSell">
                                <router-link to="/es/neonail/bestseller" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('bestseller') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/darmowa-dostawa-statystyka" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('free_delivery') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/zamowienia" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('order_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/numery-zamowien" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,19,23])">
                                        {{ $t('order_numbers') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/zamowienia-uwagi" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('notes_for_orders') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/sprzedaz-produktu" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('product_sale') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/sprzedaz-po-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('sale_by_category') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/sprzedaz-promocji-v2" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                        {{ $t('sale_promotion') }} V2
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <li v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,21,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailESProducts" aria-expanded="false">
                                {{ $t('products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailESProducts"> -->
                                <!-- <router-link to="/es/neonail/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23])" >
                                        {{ $t('list_of_products') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/es/neonail/produkty-sprzedaz" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,21,23])" >
                                        {{ $t('sale_products') }}
                                    </a>
                                </router-link> -->
                                <!-- <router-link to="/es/neonail/produkty-do-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23])" >
                                        {{ $t('assigning_products_to_categories') }}
                                    </a>
                                </router-link> -->
                                <!-- <li>
                                    <a @click.prevent="exportTree('/es/neonail/')">
                                        {{ $t('category_tree') }}
                                    </a>
                                </li> -->
                            <!-- </ul>
                        </li> -->
                        <!-- <li v-if="hasPrivilege([1,2,5,12,14,15,17,27,25,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailESDiscountCodes" aria-expanded="false">
                                {{ $t('discount_codes') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailESDiscountCodes">
                                <router-link to="/es/neonail/kody-rabatowe" tag="li">
                                    <a>
                                        {{ $t('discount_codes_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/kody-rabatowe-sprzedaz" tag="li">
                                    <a>
                                        {{ $t('sale_discount_codes') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/es/neonail/newsletter" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23])">
                                {{ $t('newsletter') }}
                            </a>
                        </router-link> -->
                        <!-- <li v-if="hasPrivilege([1])" >
                            <a data-toggle="collapse" href="#collapseNeoNailESLoyaltyCards" aria-expanded="false">
                                {{ $t('customers') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailESLoyaltyCards">
                                <router-link to="/es/neonail/klient-liczba-zamowien" tag="li">
                                    <a>
                                        {{ $t('number_of_orders_by_the_customer') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/es/neonail/metody-platnosci-statystyki" tag="li" >
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                {{ $t('payment_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/es/neonail/metody-dostawy-statystyki" tag="li" >
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,21,23])">
                                {{ $t('delivery_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/es/neonail/vat" tag="li">
                            <a v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23])">
                                {{ $t('vat') }}
                            </a>
                        </router-link> -->
                        <!-- <li v-if="hasPrivilege([1,5,12,13,14,15,17,27,25,23])">
                            <a data-toggle="collapse" href="#collapseNeoNailESComplaint" aria-expanded="false">
                                {{ $t('complaints') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailESComplaint">
                                <router-link to="/es/neonail/reklamacje" tag="li">
                                    <a>
                                        {{ $t('list_of_requests') }}
                                    </a>
                                </router-link>
                                <router-link to="/es/neonail/reklamacje/ustawienia" tag="li">
                                    <a>
                                        {{ $t('settings') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                    <!-- </ul>
                </li> -->

                <!-- <li v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,21])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#collapseMylaqPl" aria-expanded="false">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="nav-label">{{ $t('shop_mylaq_pl') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="collapseMylaqPl">

                        <li v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,21,23])" >
                            <a data-toggle="collapse" href="#collapseMylaqPlSell" aria-expanded="false">
                                {{ $t('sele') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseMylaqPlSell">
                                <router-link to="/pl/mylaq/zamowienia" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,21,23])" >
                                        {{ $t('order_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/mylaq/zamowienia-uwagi" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,21,23])" >
                                        {{ $t('notes_for_orders') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/mylaq/sprzedaz-produktu" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,21,23])" >
                                        {{ $t('product_sale') }}
                                    </a>
                                </router-link>
                                <router-link to="/pl/mylaq/sprzedaz-po-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,21,23])" >
                                        {{ $t('sale_by_category') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li>
                        <li v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailESProducts" aria-expanded="false">
                                {{ $t('products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailESProducts">
                                <router-link to="/pl/mylaq/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23])" >
                                        {{ $t('list_of_products') }}
                                    </a>
                                </router-link>
                                <li>
                                    <a @click.prevent="exportTree('/pl/mylaq/')">
                                        {{ $t('category_tree') }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <router-link to="/pl/mylaq/kody-rabatowe" tag="li">
                            <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23])" >
                                {{ $t('discount_codes') }}
                            </a>
                        </router-link>
                        <router-link to="/pl/mylaq/newsletter" tag="li">
                            <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23])" >
                                {{ $t('newsletter') }}
                            </a>
                        </router-link>
                        <router-link to="/pl/mylaq/metody-platnosci-statystyki" tag="li">
                            <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                                {{ $t('payment_methods') }}
                            </a>
                        </router-link>
                        <router-link to="/pl/mylaq/metody-dostawy-statystyki" tag="li" >
                            <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                                {{ $t('delivery_methods') }}
                            </a>
                        </router-link>
                        <router-link to="/location" tag="li" v-if="hasPrivilege([1,14,15,16])" >
                            <a>
                                <span class="nav-label">Lokalizacja</span>
                            </a>
                        </router-link>

                    </ul>
                </li> -->

                <!-- <li v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#collapseMylaqDe" aria-expanded="false">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="nav-label">{{ $t('shop_mylaq_de') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="collapseMylaqDe"> -->

                        <!-- <li v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                            <a data-toggle="collapse" href="#collapseMylaqDeSell" aria-expanded="false">
                                {{ $t('sele') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseMylaqDeSell">
                                <router-link to="/de/mylaq/zamowienia" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                                        {{ $t('order_list') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/mylaq/zamowienia-uwagi" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                                        {{ $t('notes_for_orders') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/mylaq/sprzedaz-produktu" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                                        {{ $t('product_sale') }}
                                    </a>
                                </router-link>
                                <router-link to="/de/mylaq/sprzedaz-po-kategorii" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23,21])" >
                                        {{ $t('sale_by_category') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <!-- <li v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23])" >
                            <a data-toggle="collapse" href="#collapseNeoNailESProducts" aria-expanded="false">
                                {{ $t('products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul class="nav nav-third-level collapse" id="collapseNeoNailESProducts">
                                <router-link to="/de/mylaq/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,4,5,12,14,15,17,27,25,23])" >
                                        {{ $t('list_of_products') }}
                                    </a>
                                </router-link>
                                <li>
                                    <a @click.prevent="exportTree('/de/mylaq/')">
                                        {{ $t('category_tree') }}
                                    </a>
                                </li>
                            </ul>
                        </li> -->
                        <!-- <router-link to="/de/mylaq/kody-rabatowe" tag="li">
                            <a>
                                {{ $t('discount_codes') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/de/mylaq/newsletter" tag="li">
                            <a>
                                {{ $t('newsletter') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/de/mylaq/metody-platnosci-statystyki" tag="li">
                            <a>
                                {{ $t('payment_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/de/mylaq/metody-dostawy-statystyki" tag="li" >
                            <a>
                                {{ $t('delivery_methods') }}
                            </a>
                        </router-link> -->
                        <!-- <router-link to="/de/mylaq/vat" tag="li">
                            <a>
                                {{ $t('vat') }}
                            </a>
                        </router-link> -->

                    <!-- </ul>
                </li> -->
                <!-- <li v-if="hasPrivilege([1,14,15])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#expertpl" aria-expanded="false">
                        <i class="fa fa-cogs"></i>
                        <span class="nav-label">{{ $t('expert_pl') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="expertpl">
                        <router-link to="/pl/expert" tag="li">
                            <a>
                                {{ $t('list_of_requests') }}
                            </a>
                        </router-link>
                    </ul>
                </li> -->
                <!-- <router-link to="/kontrola-platnosci" tag="li" v-if="hasPrivilege([1,14,15,16])" >
                    <a>
                        <i class="fa fa-chart-line"></i>
                        <span class="nav-label">{{ $t('payment_control') }}</span>
                    </a>
                </router-link> -->
                <!-- <router-link to="/allegro" tag="li" v-if="hasPrivilege([1,5,11])" >
                    <a>
                        <i class="fa fa-chart-line"></i>
                        <span class="nav-label">{{ $t('allegro') }}</span>
                    </a>
                </router-link> -->
                <!-- <li v-if="hasPrivilege([1,5,11])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#empik" aria-expanded="false">
                        <i class="fa fa-cogs"></i>
                        <span class="nav-label">{{ $t('empik') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="empik">
                        <router-link to="/empik" tag="li">
                            <a>
                                {{ $t('offers') }}
                            </a>
                        </router-link>
                        <router-link to="/empik/upload" tag="li">
                            <a>
                                {{ $t('upload') }}
                            </a>
                        </router-link>
                    </ul>
                </li> -->

                <!-- <li v-if="hasPrivilege([1,9])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#sales_department" aria-expanded="false">
                        <i class="fa fa-truck"></i>
                        <span class="nav-label">{{ $t('sales_department') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="sales_department">
                        <router-link to="/douglas" tag="li">
                            <a>
                                {{ $t('documents_report') }}
                            </a>
                        </router-link>
                        <router-link to="/douglas/de" tag="li">
                            <a>
                                Douglas DE
                            </a>
                        </router-link>
                        <router-link to="/douglas/pt" tag="li">
                            <a>
                                Douglas PT
                            </a>
                        </router-link>
                        <router-link to="/kontigo" tag="li">
                            <a>
                                {{ $t('kontigo') }}
                            </a>
                        </router-link>
                        <router-link to="/natura" tag="li">
                            <a>
                                {{ $t('natura') }}
                            </a>
                        </router-link>
                        <li>
                            <a @click.prevent="exportProduacts">
                                {{ $t('export_of_products') }}
                            </a>
                        </li>
                    </ul>
                </li> -->

                <!-- <li v-if="hasPrivilege([1,18])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#warehouse" aria-expanded="false">
                        <i class="fa fa-truck"></i>
                        <span class="nav-label">{{ $t('warehouse') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="warehouse">
                        <router-link to="/magazyn/raport" tag="li">
                            <a>
                                {{ $t('documents_report') }}
                            </a>
                        </router-link>
                        <router-link to="/magazyn/pracownicy" tag="li">
                            <a>
                                {{ $t('employees') }}
                            </a>
                        </router-link>
                        <router-link to="/magazyn/dokumenty" tag="li">
                            <a>
                                {{ $t('documents') }}
                            </a>
                        </router-link>
                        <router-link to="/magazyn/wgraj-pliki" tag="li">
                            <a>
                                {{ $t('upload_files') }}
                            </a>
                        </router-link>
                    </ul>
                </li> -->

                <!-- <router-link to="/tablet" tag="li" v-if="hasPrivilege([1])" >
                    <a>
                        <i class="fa fa-tablet"></i>
                        <span class="nav-label">Tablet</span>
                    </a>
                </router-link> -->
                <!-- <li v-if="hasPrivilege([1,24,1,2,5,12,14,15,17,27,25,19,21,23])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#comparison" aria-expanded="false">
                        <i class="fa fa-arrows-h"></i>
                        <span class="nav-label">{{ $t('comparison') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="comparison">
                        <router-link to="/porownywarka" tag="li">
                            <a>
                                {{ $t('comparison-list') }}
                            </a>
                        </router-link>
                        <router-link to="/porownywarka/kategorie" tag="li" v-if="hasPrivilege([1])" >
                            <a>
                                {{ $t('comparison-categories-list') }}
                            </a>
                        </router-link>
                        <router-link to="/porownywarka/parametry" tag="li" v-if="hasPrivilege([1])" >
                            <a>
                                {{ $t('comparison-parameters-list') }}
                            </a>
                        </router-link>
                    </ul>
                </li> -->

                <li v-if="hasPrivilege([1,5,12,27])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#fitting-dev" aria-expanded="false">
                        <i class="fa fa-arrows-h"></i>
                        <span class="nav-label">{{ $t('fitting') }} DEV</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="fitting-dev">
                        <router-link to="/przymierzalnia/dev/banners" tag="li">
                            <a>
                                {{ $t('fitting-banners') }}
                            </a>
                        </router-link>
                        <li v-if="hasPrivilege([1,5,12,27])" >
                            <a data-toggle="collapse" href="#fitting-dev-product" aria-expanded="false">
                                {{ $t('fitting-products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul v-if="hasPrivilege([1,5,12,27])" class="nav nav-third-level collapse" id="fitting-dev-product">
                                <router-link to="/przymierzalnia/dev/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,27])">
                                        {{ $t('list') }}
                                    </a>
                                </router-link>
                                <router-link to="/przymierzalnia/dev/kolejnosc-produktow" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,27])">
                                        {{ $t('sort') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li>
                        <router-link to="/przymierzalnia/dev/produkty-w-kategori" tag="li">
                            <a>
                                {{ $t('fitting-products-in-category') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/dev/kategorie" tag="li">
                            <a>
                                {{ $t('fitting-categories') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/dev/parametry" tag="li">
                            <a>
                                {{ $t('fitting-parameters') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/dev/parametryTypy" tag="li">
                            <a>
                                Typy parametrów
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/dev/sklepy" tag="li">
                            <a>
                                {{ $t('fitting-shops') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/dev/koszyki" tag="li">
                            <a>
                                {{ $t('fitting-shopping-carts') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/dev/lista-zyczen" tag="li">
                            <a>
                                {{ $t('fitting-wish-list') }}
                            </a>
                        </router-link>
                    </ul>
                </li>
                <li v-if="hasPrivilege([1,5,12,27])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#fitting-prod" aria-expanded="false">
                        <i class="fa fa-arrows-h"></i>
                        <span class="nav-label">{{ $t('fitting') }} PROD</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="fitting-prod">
                        <router-link to="/przymierzalnia/prod/banners" tag="li">
                            <a>
                                {{ $t('fitting-banners') }}
                            </a>
                        </router-link>
                        <li v-if="hasPrivilege([1,5,12,27])" >
                            <a data-toggle="collapse" href="#fitting-prod-product" aria-expanded="false">
                                {{ $t('fitting-products') }}
                                <span class="fa arrow"></span>
                            </a>
                            <ul v-if="hasPrivilege([1,5,12,27])" class="nav nav-third-level collapse" id="fitting-prod-product">
                                <router-link to="/przymierzalnia/prod/produkty" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,27])">
                                        {{ $t('list') }}
                                    </a>
                                </router-link>
                                <router-link to="/przymierzalnia/prod/kolejnosc-produktow" tag="li">
                                    <a v-if="hasPrivilege([1,5,12,27])">
                                        {{ $t('sort') }}
                                    </a>
                                </router-link>
                            </ul>
                        </li>
                        <router-link to="/przymierzalnia/prod/produkty-w-kategori" tag="li">
                            <a>
                                {{ $t('fitting-products-in-category') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/prod/kategorie" tag="li">
                            <a>
                                {{ $t('fitting-categories') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/prod/parametry" tag="li">
                            <a>
                                {{ $t('fitting-parameters') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/prod/parametryTypy" tag="li">
                            <a>
                                Typy parametrów
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/prod/sklepy" tag="li">
                            <a>
                                {{ $t('fitting-shops') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/prod/koszyki" tag="li">
                            <a>
                                {{ $t('fitting-shopping-carts') }}
                            </a>
                        </router-link>
                        <router-link to="/przymierzalnia/prod/lista-zyczen" tag="li">
                            <a>
                                {{ $t('fitting-wish-list') }}
                            </a>
                        </router-link>
                    </ul>
                </li>

                <!-- <router-link to="/terminarz" tag="li" v-if="hasPrivilege([1])" >
                    <a>
                        <i class="fa fa-calendar"></i>
                        <span class="nav-label">{{ $t('timetable') }}</span>
                    </a>
                </router-link> -->
                <li v-if="hasPrivilege([1])" >
                    <a class="nav-collapse-controller" data-toggle="collapse" href="#settings" aria-expanded="false">
                        <i class="fa fa-cogs"></i>
                        <span class="nav-label">{{ $t('settings') }}</span>
                        <span class="fa arrow"></span>
                    </a>
                    <ul class="nav nav-second-level collapse" id="settings">
                        <router-link to="/ustawienia/uzytkownicy" tag="li">
                            <a>
                                {{ $t('users') }}
                            </a>
                        </router-link>
                    </ul>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Navbar',
    computed: {
        ...mapGetters( 'users', [ 'name', 'roles' ] ),
        position_title() {
            if ( this.roles ) {
                return this.roles.name
            }
            return 'Pracownik'
        }
    },
    created() {
        this.initNav()
    },
    methods: {
        hasPrivilege( privilege ){
            return privilege.includes( this.roles.id )
        },
        expand( e ) {
            e.preventDefault()
        },
        subIsActive( input ) {
            const paths = Array.isArray( input ) ? input : [ input ]

            return paths.some( path =>
                this.$route.path.indexOf( path ) === 0 // current path starts with this path string
            )
        },
        initNav(){
            $( document ).on( 'show.bs.collapse', function( e ) { // eslint-disable-line
                $( e.target ).parent().addClass( 'active' ) // eslint-disable-line
            } )

            $( document ).on( 'hide.bs.collapse', function( e ) { // eslint-disable-line
                $( e.target ).parent().removeClass( 'active' ) // eslint-disable-line
            } )
        },
        exportProduacts() {
            this.$http( {
                url: 'pl/neonail/export/products',
                method: 'get',
                responseType: 'blob'
                } )
                .then( response => {
                    const url = window.URL.createObjectURL( new Blob( [ response.data ] ) )
                    const link = document.createElement( 'a' )
                    link.href = url
                    link.setAttribute( 'download', 'test.xlsx' )
                    document.body.appendChild( link )
                    link.click()
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        },
        exportTree( uri ) {
            this.$http( {
                url: `${uri}/products/tree`,
                method: 'post',
                responseType: 'blob'
            } )
                .then( response => {
                    const url = window.URL.createObjectURL( new Blob( [ response.data ] ) )
                    const link = document.createElement( 'a' )
                    link.href = url
                    link.setAttribute( 'download', 'test.xlsx' )
                    document.body.appendChild( link )
                    link.click()
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        }

    }
}
</script>

<style lang="scss" scoped>
    // a[aria-expanded="true"] {

    //     .arrow {
    //         &::before {
    //             content: "\f107";
    //         }
    //     }

    // }
    // a[aria-expanded="false"] {
    //     ~ ul.nav {
    //         display: none;
    //     }
    // }
</style>
